/* eslint-disable camelcase */

import React, { useCallback, useContext } from "react";
import { useFormikContext } from "formik";

import {
  HvGlobalActions,
  HvGrid,
  HvDropdown,
  ListValueProp,
  HvTypography,
} from "@hitachivantara/uikit-react-core";
import { SwitchWithLabels } from "components/form";

import { useTranslation } from "react-i18next";
import { IncidentType } from "lib/api";
import { NavigationContext } from "lib/context/NavigationContext";
import useStyles from "./styles";

const IncidentTypeOptions: React.FC = () => {
  const { t } = useTranslation("addEditIncidentType");
  const { enableCustomDashboard } = useContext(NavigationContext);
  const {
    values: { refresh_intervals = 0, has_timeline, has_advanced_insights },
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<Partial<IncidentType>>();

  const classes = useStyles();

  const onRefreshIntervalChange = useCallback(
    (selection: ListValueProp | ListValueProp[] | undefined) => {
      const selectedValue = selection as ListValueProp;
      setFieldValue(
        "refresh_intervals",
        selectedValue ? Number(selectedValue.id) : 0
      );
      setFieldTouched("refresh_intervals", true, false);
    },
    [setFieldValue, setFieldTouched]
  );

  return (
    <HvGrid className={classes.root} container>
      <HvGrid item sm={12}>
        <HvGlobalActions
          title={t("sections.options.title")}
          variant="section"
        />
        <HvTypography variant="normalText">
          {t("sections.options.description")}
        </HvTypography>
      </HvGrid>

      <HvGrid container className={classes.fields} item xs={12} lg={9}>
        <HvGrid item xs={12} md={6}>
          <HvDropdown
            label={t("options.refreshIntervals.title")}
            required
            values={[3, 5, 10, 30, 60, 600, 1800, 3600, 0].map((val) => ({
              id: `${val}`,
              label: t(`options.refreshIntervals.labels.${val}`),
              selected: val === refresh_intervals,
            }))}
            onChange={onRefreshIntervalChange}
          />
        </HvGrid>

        <HvGrid item xs={12} md={3}>
          <SwitchWithLabels
            name="has_timeline"
            label={t("options.hasTimeline.labels.title")}
            offLabel={t("options.hasTimeline.labels.no")}
            onLabel={t("options.hasTimeline.labels.yes")}
            checked={has_timeline}
            value={has_timeline ? "yes" : "no"}
            onChange={(evt, value) => {
              setFieldTouched("has_timeline");
              setFieldValue("has_timeline", value);
            }}
            onBlur={() => {
              setFieldTouched("has_timeline");
            }}
          />
        </HvGrid>
        {enableCustomDashboard && (
          <HvGrid item xs={12} md={3}>
            <SwitchWithLabels
              name="has_advanced_insights"
              label={t("options.hasAdvancedInsights.labels.title")}
              offLabel={t("options.hasAdvancedInsights.labels.no")}
              onLabel={t("options.hasAdvancedInsights.labels.yes")}
              checked={has_advanced_insights}
              value={has_advanced_insights ? "yes" : "no"}
              onChange={(evt, value) => {
                setFieldTouched("has_advanced_insights");
                setFieldValue("has_advanced_insights", value);
              }}
              onBlur={() => {
                setFieldTouched("has_advanced_insights");
              }}
            />
          </HvGrid>
        )}
      </HvGrid>
    </HvGrid>
  );
};

export default IncidentTypeOptions;
